import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTanulmanyiKorulmenyek, createTanulmanyiKorulmenyek, updateTanulmanyiKorulmenyek, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import "./RadioButton.css";
import "./SzakjelentesCreate.css";
import SideTile from "../SideTile";
import { useFormSave } from "../../context/FormSaveContext";
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import TopAlert from '../../components/TopAlert';
import {
    SZAKMENTON_RENDSZER_OPTIONS,
    TANULMANYI_TABLAZATOK_OPTIONS,
    OKTATOI_KONZULTACIO_OPTIONS,
    FELZARKOZTATO_KEPZESEK_OPTIONS,
    TEHETSEGGONDOZASI_LEHETOSEGEK_OPTIONS,
    SZAKMAI_GYAKORLAT_OPTIONS,
    OKTATASI_SEGEDANYAGOK_OPTIONS,
    DIGITALIS_TANANYAGOK_OPTIONS,
    DIGITALIS_ESZKOZOK_OPTIONS
} from './TanulmanyiKorulmenyekOptions';
import { TANULMANYI_KORULMENYEK_TRANSLATIONS } from './TanulmanyiKorulmenyekTranslations';


const TanulmanyiKorulmenyekContent = ({ szakKod }) => {
    console.log('TanulmanyiKorulmenyekContent rendering with szakKod:', szakKod);

    const [isSideTileVisible] = useState(true);
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();
    const { language, loading } = useLanguage();

    console.log('TanulmanyiKorulmenyekContent language state:', { language, loading });

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    const [tanulmanyiKorulmenyek, setTanulmanyiKorulmenyek] = useState({
        filling_status: 1,
    });

    // State for radio button selections
    const [szakmentonRendszer, setSzakmentonRendszer] = useState("");
    const [tanulmanyiTablazatok, setTanulmanyiTablazatok] = useState("");
    const [oktatoiKonzultacio, setOktatoiKonzultacio] = useState("");
    const [felzarkoztatoKepzesek, setFelzarkoztatoKepzesek] = useState("");
    const [tehetseggondozasiLehetosegek, setTehetseggondozasiLehetosegek] = useState("");
    const [szakmaiGyakorlat, setSzakmaiGyakorlat] = useState("");
    const [oktatoiSegedanyagok, setOktatoiSegedanyagok] = useState("");
    const [digitalisTananyagok, setDigitalisTananyagok] = useState("");
    const [digitalisEszkozok, setDigitalisEszkozok] = useState("");

    const [isNew, setIsNew] = useState(true);
    const [finalized, setFinalized] = useState(false);
    const [szakStatus, setSzakStatus] = useState(1);

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Get translations and options for current language
    const t = loading ? {} : (TANULMANYI_KORULMENYEK_TRANSLATIONS[language] || TANULMANYI_KORULMENYEK_TRANSLATIONS.hu);
    console.log('TanulmanyiKorulmenyekContent translations:', { loading, language, hasSidebar: !!t.sidebar, t });
    
    const szakmentonRendszerOptions = loading ? [] : (SZAKMENTON_RENDSZER_OPTIONS[language] || SZAKMENTON_RENDSZER_OPTIONS.hu);
    const tanulmanyiTablazatokOptions = loading ? [] : (TANULMANYI_TABLAZATOK_OPTIONS[language] || TANULMANYI_TABLAZATOK_OPTIONS.hu);
    const oktatoiKonzultacioOptions = loading ? [] : (OKTATOI_KONZULTACIO_OPTIONS[language] || OKTATOI_KONZULTACIO_OPTIONS.hu);
    const felzarkoztatoKepzesekOptions = loading ? [] : (FELZARKOZTATO_KEPZESEK_OPTIONS[language] || FELZARKOZTATO_KEPZESEK_OPTIONS.hu);
    const tehetseggondozasiLehetosegekOptions = loading ? [] : (TEHETSEGGONDOZASI_LEHETOSEGEK_OPTIONS[language] || TEHETSEGGONDOZASI_LEHETOSEGEK_OPTIONS.hu);
    const szakmaiGyakorlatOptions = loading ? [] : (SZAKMAI_GYAKORLAT_OPTIONS[language] || SZAKMAI_GYAKORLAT_OPTIONS.hu);
    const oktatoiSegedanyagokOptions = loading ? [] : (OKTATASI_SEGEDANYAGOK_OPTIONS[language] || OKTATASI_SEGEDANYAGOK_OPTIONS.hu);
    const digitalisTananyagokOptions = loading ? [] : (DIGITALIS_TANANYAGOK_OPTIONS[language] || DIGITALIS_TANANYAGOK_OPTIONS.hu);
    const digitalisEszkozokOptions = loading ? [] : (DIGITALIS_ESZKOZOK_OPTIONS[language] || DIGITALIS_ESZKOZOK_OPTIONS.hu);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getTanulmanyiKorulmenyek(szakId);
                if (response.data && response.data.data) {
                    const data = response.data.data;
                    setTanulmanyiKorulmenyek(data);
                    setFinalized(data.filling_status === 3);
                    
                    // Load radio button selections from JSONB
                    if (data.szakmenton_rendszer) setSzakmentonRendszer(data.szakmenton_rendszer.selected || "");
                    if (data.tanulmanyi_tablazatok) setTanulmanyiTablazatok(data.tanulmanyi_tablazatok.selected || "");
                    if (data.oktatoi_konzultacio) setOktatoiKonzultacio(data.oktatoi_konzultacio.selected || "");
                    if (data.felzarkoztato_kepzesek) setFelzarkoztatoKepzesek(data.felzarkoztato_kepzesek.selected || "");
                    if (data.tehetseggondozasi_lehetosegek) setTehetseggondozasiLehetosegek(data.tehetseggondozasi_lehetosegek.selected || "");
                    if (data.szakmai_gyakorlat) setSzakmaiGyakorlat(data.szakmai_gyakorlat.selected || "");
                    if (data.oktatasi_segedanyagok) setOktatoiSegedanyagok(data.oktatasi_segedanyagok.selected || "");
                    if (data.digitalis_tananyagok) setDigitalisTananyagok(data.digitalis_tananyagok.selected || "");
                    if (data.digitalis_eszkozok) setDigitalisEszkozok(data.digitalis_eszkozok.selected || "");
                    
                    setIsNew(false);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                // Handle case when no record exists (404)
                if (error.response && error.response.status === 404) {
                    const newData = {
                        filling_status: 1,
                    };
                    try {
                        await createTanulmanyiKorulmenyek(szakId, newData);
                        setTanulmanyiKorulmenyek(newData);
                        window.location.reload();
                    } catch (createError) {
                        console.error("Error creating initial record:", createError);
                    }
                }
            }
        };
        fetchData();
    }, [szakId]);

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...tanulmanyiKorulmenyek, 
                filling_status: 2,
                szakmenton_rendszer: buildRadioData(szakmentonRendszer, szakmentonRendszerOptions),
                tanulmanyi_tablazatok: buildRadioData(tanulmanyiTablazatok, tanulmanyiTablazatokOptions),
                oktatoi_konzultacio: buildRadioData(oktatoiKonzultacio, oktatoiKonzultacioOptions),
                felzarkoztato_kepzesek: buildRadioData(felzarkoztatoKepzesek, felzarkoztatoKepzesekOptions),
                tehetseggondozasi_lehetosegek: buildRadioData(tehetseggondozasiLehetosegek, tehetseggondozasiLehetosegekOptions),
                szakmai_gyakorlat: buildRadioData(szakmaiGyakorlat, szakmaiGyakorlatOptions),
                oktatasi_segedanyagok: buildRadioData(oktatoiSegedanyagok, oktatoiSegedanyagokOptions),
                digitalis_tananyagok: buildRadioData(digitalisTananyagok, digitalisTananyagokOptions),
                digitalis_eszkozok: buildRadioData(digitalisEszkozok, digitalisEszkozokOptions)
            };
            try {
                if (isNew) {
                    await createTanulmanyiKorulmenyek(szakId, updatedData);
                } else {
                    await updateTanulmanyiKorulmenyek(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [szakmentonRendszer, tanulmanyiTablazatok, oktatoiKonzultacio, felzarkoztatoKepzesek,
        tehetseggondozasiLehetosegek, szakmaiGyakorlat, oktatoiSegedanyagok, digitalisTananyagok,
        digitalisEszkozok, tanulmanyiKorulmenyek, isNew, szakId, registerSaveHandler, unregisterSaveHandler]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        
        const updatedData = { 
            ...tanulmanyiKorulmenyek, 
            filling_status: status,
            szakmenton_rendszer: buildRadioData(szakmentonRendszer, szakmentonRendszerOptions),
            tanulmanyi_tablazatok: buildRadioData(tanulmanyiTablazatok, tanulmanyiTablazatokOptions),
            oktatoi_konzultacio: buildRadioData(oktatoiKonzultacio, oktatoiKonzultacioOptions),
            felzarkoztato_kepzesek: buildRadioData(felzarkoztatoKepzesek, felzarkoztatoKepzesekOptions),
            tehetseggondozasi_lehetosegek: buildRadioData(tehetseggondozasiLehetosegek, tehetseggondozasiLehetosegekOptions),
            szakmai_gyakorlat: buildRadioData(szakmaiGyakorlat, szakmaiGyakorlatOptions),
            oktatasi_segedanyagok: buildRadioData(oktatoiSegedanyagok, oktatoiSegedanyagokOptions),
            digitalis_tananyagok: buildRadioData(digitalisTananyagok, digitalisTananyagokOptions),
            digitalis_eszkozok: buildRadioData(digitalisEszkozok, digitalisEszkozokOptions)
        };

        try {
            if (isNew) {
                await createTanulmanyiKorulmenyek(szakId, updatedData);
            } else {
                await updateTanulmanyiKorulmenyek(szakId, updatedData);
            }

            window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/szak-kommunikacioja`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/oktatok-ertekelese`);
    };

    const isFormValid = () => {
        return (
            szakmentonRendszer &&
            tanulmanyiTablazatok &&
            oktatoiKonzultacio &&
            felzarkoztatoKepzesek &&
            tehetseggondozasiLehetosegek &&
            szakmaiGyakorlat &&
            oktatoiSegedanyagok &&
            digitalisTananyagok &&
            digitalisEszkozok
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3);
        } else {
            setAlertMessage(t.alerts.requiredFields);
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = async (e) => {
        e.preventDefault();
        const updatedData = { 
            ...tanulmanyiKorulmenyek, 
            filling_status: 2,
            szakmenton_rendszer: buildRadioData(szakmentonRendszer, szakmentonRendszerOptions),
            tanulmanyi_tablazatok: buildRadioData(tanulmanyiTablazatok, tanulmanyiTablazatokOptions),
            oktatoi_konzultacio: buildRadioData(oktatoiKonzultacio, oktatoiKonzultacioOptions),
            felzarkoztato_kepzesek: buildRadioData(felzarkoztatoKepzesek, felzarkoztatoKepzesekOptions),
            tehetseggondozasi_lehetosegek: buildRadioData(tehetseggondozasiLehetosegek, tehetseggondozasiLehetosegekOptions),
            szakmai_gyakorlat: buildRadioData(szakmaiGyakorlat, szakmaiGyakorlatOptions),
            oktatasi_segedanyagok: buildRadioData(oktatoiSegedanyagok, oktatoiSegedanyagokOptions),
            digitalis_tananyagok: buildRadioData(digitalisTananyagok, digitalisTananyagokOptions),
            digitalis_eszkozok: buildRadioData(digitalisEszkozok, digitalisEszkozokOptions)
        };

        try {
            await updateTanulmanyiKorulmenyek(szakId, updatedData);
            window.location.reload();
        } catch (error) {
            console.error("Error reverting finalize:", error);
        }
    };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    if (!t || !t.sidebar) {
        console.error('TanulmanyiKorulmenyek: Missing translations or sidebar', { t, language, loading });
        return <div>Error: Missing translations</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
            isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1 className="esg-title">{t.esgTitle}</h1>
                <h1>{t.sectionTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    <div className="card">

                        <h4>{t.szakmentonRendszer}</h4>
                        <div className="form-group">
                            {szakmentonRendszerOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`szakmenton_rendszer_${option.value}`}
                                        name="szakmenton_rendszer"
                                        value={option.value}
                                        checked={szakmentonRendszer === option.value}
                                        onChange={(e) => setSzakmentonRendszer(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`szakmenton_rendszer_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.tanulmanyiTablazatok}</h4>
                        <div className="form-group">
                            {tanulmanyiTablazatokOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`tanulmanyi_tablazatok_${option.value}`}
                                        name="tanulmanyi_tablazatok"
                                        value={option.value}
                                        checked={tanulmanyiTablazatok === option.value}
                                        onChange={(e) => setTanulmanyiTablazatok(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`tanulmanyi_tablazatok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.oktatoiKonzultacio}</h4>
                        <div className="form-group">
                            {oktatoiKonzultacioOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`oktatoi_konzultacio_${option.value}`}
                                        name="oktatoi_konzultacio"
                                        value={option.value}
                                        checked={oktatoiKonzultacio === option.value}
                                        onChange={(e) => setOktatoiKonzultacio(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`oktatoi_konzultacio_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.felzarkoztatoKepzesek}</h4>
                        <div className="form-group">
                            {felzarkoztatoKepzesekOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`felzarkoztato_kepzesek_${option.value}`}
                                        name="felzarkoztato_kepzesek"
                                        value={option.value}
                                        checked={felzarkoztatoKepzesek === option.value}
                                        onChange={(e) => setFelzarkoztatoKepzesek(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`felzarkoztato_kepzesek_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.tehetseggondozasiLehetosegek}</h4>
                        <div className="form-group">
                            {tehetseggondozasiLehetosegekOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`tehetseggondozasi_lehetosegek_${option.value}`}
                                        name="tehetseggondozasi_lehetosegek"
                                        value={option.value}
                                        checked={tehetseggondozasiLehetosegek === option.value}
                                        onChange={(e) => setTehetseggondozasiLehetosegek(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`tehetseggondozasi_lehetosegek_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.szakmaiGyakorlat}</h4>
                        <div className="form-group">
                            {szakmaiGyakorlatOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`szakmai_gyakorlat_${option.value}`}
                                        name="szakmai_gyakorlat"
                                        value={option.value}
                                        checked={szakmaiGyakorlat === option.value}
                                        onChange={(e) => setSzakmaiGyakorlat(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`szakmai_gyakorlat_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.oktatoiSegedanyagok}</h4>
                        <div className="form-group">
                            {oktatoiSegedanyagokOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`oktatasi_segedanyagok_${option.value}`}
                                        name="oktatasi_segedanyagok"
                                        value={option.value}
                                        checked={oktatoiSegedanyagok === option.value}
                                        onChange={(e) => setOktatoiSegedanyagok(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`oktatasi_segedanyagok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.digitalisTananyagok}</h4>
                        <div className="form-group">
                            {digitalisTananyagokOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`digitalis_tananyagok_${option.value}`}
                                        name="digitalis_tananyagok"
                                        value={option.value}
                                        checked={digitalisTananyagok === option.value}
                                        onChange={(e) => setDigitalisTananyagok(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`digitalis_tananyagok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>

                        <h4>{t.digitalisEszkozok}</h4>
                        <div className="form-group">
                            {digitalisEszkozokOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`digitalis_eszkozok_${option.value}`}
                                        name="digitalis_eszkozok"
                                        value={option.value}
                                        checked={digitalisEszkozok === option.value}
                                        onChange={(e) => setDigitalisEszkozok(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`digitalis_eszkozok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="button-container">
                        <button className="szak-button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button 
                            className="szak-button" 
                            type="submit" 
                            disabled={finalized || szakStatus >= 2}
                        >
                            {t.buttons.save}
                        </button>
                        {finalized ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>
                                {t.buttons.unfinalize}
                            </button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>
                                {t.buttons.finalize}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

const TanulmanyiKorulmenyek = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    console.log('TanulmanyiKorulmenyek wrapper rendering', { szakId, szakKod, error });

    useEffect(() => {
        const fetchSzakKod = async () => {
            console.log('Fetching szakKod for szakId:', szakId);
            try {
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                console.log('getSzak response.data:', response.data);
                console.log('getSzak response.data.data:', response.data?.data);
                
                if (response.data && response.data.data) {
                    // response.data.data is an object, not an array
                    const szakData = response.data.data;
                    const kod = Array.isArray(szakData) ? szakData[0]?.szak_kod : szakData.szak_kod;
                    console.log('Setting szakKod to:', kod);
                    setSzakKod(kod);
                } else {
                    console.error('No data in getSzak response. Full response:', JSON.stringify(response.data));
                    setError("Unable to load program code");
                }
            } catch (err) {
                console.error("Error fetching program code:", err);
                setError("Error loading program code");
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        console.log('Rendering error state:', error);
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        console.log('Rendering loading state, szakKod is:', szakKod);
        return <div>Loading page...</div>;
    }

    console.log('Rendering LanguageProvider with szakKod:', szakKod);
    return (
        <LanguageProvider szakKod={szakKod}>
            <TanulmanyiKorulmenyekContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default TanulmanyiKorulmenyek;
